import {inject, Injectable} from '@angular/core';
import {AuthUserService} from "@common-module/app-services/auth-user.service";
import {UiSpinnerService} from "@common-module/app-services/ui-spinner.service";

@Injectable({
  providedIn: 'root'
})
export class AdminPortalAuthUserService extends AuthUserService{

  protected readonly uiSpinnerService: UiSpinnerService = inject(UiSpinnerService);

  constructor() {
    super();
  }

  public override init(): void {
    this.isAdmin = true;
    super.init();
  }

  public override update(): void {
    this.uiSpinnerService.show();
    this.authRestService.getDetails().subscribe(auth => {
      this.change(auth.realAuthUser);
      this.uiSpinnerService.stop();
    });
  }
}
